import { apiCall } from "../../utils/servicesUtils"

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const apiPostCropImage = (
    pictureId: string,
    x: number,
    y: number,
    width: number,
    height: number,
    devicePixelRatio: number,
    projectId: string,
    threadId: string
): Promise<{}> => {
    const urlFetch = `${BASE_URL}/api/v2/crop`
    const formData = new FormData()
    formData.append('picture_id', pictureId)

    formData.append('x', x.toString())
    formData.append('y', y.toString())
    formData.append('width', width.toString())
    formData.append('height', height.toString())
    formData.append('device_pixel_ratio', devicePixelRatio.toString())

    formData.append('project_id', projectId)
    formData.append('thread_id', threadId)

    return apiCall(
        urlFetch,
        'POST',
        formData,
        true
    )
}
